<div class="hero-bg"></div>
<div class="section-left-text ml-5">
	<h1 class="mb-3">{{'stv-landing-header' | translate | async}}</h1>
	<div class="mb-5">
		<ul>
			<li>{{'stv-landing-list-1' | translate | async}}</li>
            <li>{{'stv-landing-list-2' | translate | async}}</li>
            <li>{{'stv-landing-list-3' | translate | async}}</li>
            <li>{{'stv-landing-list-4' | translate | async}}</li>
		</ul>
	</div>
	<div class="text-center" dpadZone="'landing'">
		<button class="btn btn-primary btn-block font-weight-bold mt-5 mb-3 w-75 dpad-start"
			(click)="redirectToLoginPage()" dpadSelectable tabindex="0">
            Log into your account
        </button>
		<button class="btn btn-secondary btn-block font-weight-bold mt-5 mb-3 w-75"
			(click)="redirectToSignup()" dpadSelectable tabindex="1">
            Sign Up
        </button>
	</div>
</div>
